<div class="modal-header">
    <h4 class="modal-title pull-left mt-2">
        <i class="fa fa-list color-blue"></i>&nbsp;
        <b>{{'ORDER_DETAIL' |translate |uppercase }}</b>
    </h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span class="color-red" aria-hidden="true">&times;</span>
    </button>

</div>

<div class="modal-body">

    <div class="user-data">

        <div class="col-lg-12 col-md-12 col-sm-12 bg-light-grey mt-2 mb-3">

            <div class="col-lg-12 col-md-12 col-sm-12">
                <h4>
                    <i class="fa fa-bars color-blue"></i>&nbsp;
                    <b>{{ "Order"|uppercase }}</b>
                </h4>
            </div>

            <hr>

            <p *ngIf="order.orderConsecutive">
                <em class="fa fa-hashtag"></em>&nbsp;
                <b>{{order.orderConsecutive}}</b>
            </p>


            <p>
                <em class="fa fa-calendar color-blue"></em>&nbsp;&nbsp;
                <span>
                    {{order.orderCreation | dateTimeLocalize : false : 'YYYY-MM-DD HH:mm:ss' | async  }}
                </span>
            </p>

            <p>
                <em class="fa fa-cutlery color-blue"></em>&nbsp;&nbsp;
                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.dineIn">
                    <b class="color-green">{{ "DINE_IN" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.counter">
                    <b class="color-green">{{ "COUNTER" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder && order.orderPhoneType == 1">
                    <b class="color-green">{{ "PICKUP" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder&& order.orderPhoneType == 2">
                    <b class="color-green">{{ "DELIVERY" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder && (order.orderPhoneType === phoneOrderTypeConstants.table || order.orderPhoneType === phoneOrderTypeConstants.turn || order.orderPhoneType === phoneOrderTypeConstants.turnAutomatic)">
                    <b class="color-green">{{ "DINE_IN" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.barTab">
                    <b class="color-green">{{ "BAR_TAB" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordOrderType === orderTypeConstants.driveThru">
                    <b class="color-green"> {{ "DRIVE_THRU" | translate| uppercase }}</b>
                </ng-container>

                <ng-container *ngIf="order.ordStatus === 5">
                    &nbsp;&nbsp;&nbsp;<b class="label-deferred-order"> {{"Deferred"|translate|uppercase}}</b>
                </ng-container>

            </p>


            <p *ngIf="order.dineInTurn">
                <em class="fa fa-ticket color-blue"></em>&nbsp;
                <span *ngIf="order.ordDineInType === DINE_IN_CONSTANTS.TABLE">
                    <b class="color-green">{{'TABLE' | translate| uppercase }}:</b>
                </span>
                <span *ngIf="order.ordDineInType === DINE_IN_CONSTANTS.BEACON">
                    <b class="color-green">{{'BEACON' | translate| uppercase }}:</b>
                </span>

                <span>{{ order.dineInTurn }}</span>
            </p>

            <p>
                <em class="fa fa-user color-blue"></em>&nbsp;&nbsp;
                <span>
                    <b>{{ order.clientName }} {{ order.clientLastName }}</b>
                </span>
            </p>

            <p *ngIf="order.uponDelivery == 0">
                <em *ngIf="order.uponDelivery == 0" class="fa fa-credit-card color-blue"></em>&nbsp;&nbsp;
                <span>{{ "credit_card" | translate}}</span>
            </p>

            <p *ngIf="isColombia && order.uponDelivery == 1">
                <em *ngIf="order.ordPayMethod == 'credit_card' || order.ordPayMethod  == 'cardDeb' || order.ordPayMethod == 'credit_debit'" class="fa fa-credit-card color-blue"></em>
                <em *ngIf="order.ordPayMethod == 'cash'" class="fa fa-money color-blue"></em>
                <span class="ml-1">
                    <b> {{ "UPON_DELIVERY" | translate}} - {{order.ordPayMethod | translate}} </b>
                </span>
                &nbsp;&nbsp;
                <span *ngIf="order.ordPayMethod == 'cash'">
                    <b class="color-green"> {{order.ordPayMount | currencySD: restaurantCountry }} </b>
                </span>

            </p>

            <p *ngIf="order.orderAddress">
                <em class="fa fa-map-marker"></em>&nbsp;&nbsp;
                <span>{{order.orderAddress}}</span>
            </p>

            <p *ngIf="orderAddressComment">
                <em class="fa fa-sticky-note-o" aria-hidden="true"></em>&nbsp;&nbsp;
                <span>{{'NOTE' | translate }} {{'Delivery' | translate}}: {{orderAddressComment}}</span>
            </p>

            <p>
                <em class="fa fa-phone"></em>&nbsp;&nbsp;
                <span *ngIf="order.clientPhone">
                    {{order.clientPhone}}
                </span>
            </p>

        </div>

        <hr>

        <app-loading-image *ngIf="!isLoadingDataRestaurant" [classCSS]="'margin-processing'" [message]="'processing' | translate">

        </app-loading-image>
        
        <ng-container *ngIf="isLoadingDataRestaurant">
            
            <div class="col-lg-12 col-md-12 col-sm-12 bg-light-grey">

                <div class="col-lg-12 col-md-12 col-sm-12">
                    <h4>
                        <i class="fa fa-building color-blue"></i>&nbsp;
                        <b>{{"Restaurant Detail"|uppercase}}</b>
                    </h4>
                </div>

                <hr> 

                <p>
                    <span>
                        <b>{{restaurantDetails.name}}</b>
                    </span>
                </p>

                <p>
                    <em class="fa fa-map-marker"></em>&nbsp;&nbsp;
                    <span *ngIf="restaurantDetails.address">
                        {{restaurantDetails.address.naturalAddress}}
                    </span>
                </p>

                <p>
                    <em class="fa fa-phone"></em>&nbsp;&nbsp;
                    <span *ngIf="restaurantDetails.phones">
                        {{restaurantDetails.phones[0].number}}
                    </span>
                </p>
            </div>

        </ng-container>

    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 bg-light-grey">

        <caption></caption>

        <ng-container *ngIf="additionalDetailData && isLoadingDataRestaurant">

            <div class="col-lg-12 col-md-12 col-sm-12">

                <h4>
                    <i class="fa fa-shopping-cart color-blue"></i>&nbsp;
                    <b>{{"Products"|uppercase}}</b>
                </h4>
    
            </div>

            <hr>

            <!-- Cabecera Productos -->
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex thead-table-bg-dark p-2">

                <div class="col-lg-4 col-md-4 col-sm-12 text-center">
                    <b>{{ 'Product' | translate }}</b>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 text-center">
                    <b>{{ 'Size' | translate }}</b>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 text-right">
                    <b>{{ 'Value' | translate }}</b>
                </div>

            </div>

            <!-- Productos & Modificadores -->
            <ng-container *ngFor="let product of additionalDetailData.orderDetail">

                <div class="col-lg-12 col-md-12 col-sm-12 d-flex">

                    <div class="col-lg-6 col-md-6 col-sm-12 text-left">
                        
                        <span>
                            <b class="color-blue">{{product.qty | number: '1.0-0'}}</b>&nbsp;&nbsp;
                            <b class="text-center">{{product.name}}</b>
                        </span>
                        
                        <br>

                        <span *ngIf="product.odeStatus == 2 && product.odeDateDeferred != null" class="label-deferred-order-detail"> 
                            <b>{{ product.odeDateDeferred.date | dateTimeLocalize : false : 'YYYY-MM-DD HH:mm:ss' | async }}</b>
                        </span>

                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-12 text-left">
                        <span *ngIf="product.nameSize"><b>{{product.nameSize}}</b></span>
                        <span *ngIf="!product.nameSize"><b>{{ 'Regular' | translate}}</b></span>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-12 text-right">
                        <b>{{product.subTotal | currencySD: restaurantCountry }}</b>
                    </div>

                </div>

                <!-- Modificadores -->
                <ng-container *ngIf="product.orderObservation">

                    <ng-container *ngFor="let modifiers of product.orderObservation.products">

                        <div class="col-lg-12 col-md-12 col-sm-12 modifiers d-flex">
                            
                            <div class="col-lg-6 col-md-6">
                                <b class="color-light-blue">
                                    {{modifiers.qty | number: '1.0-0'}}&nbsp;&nbsp;
                                    {{modifiers.name}}
                                </b>
                            </div>

                            <div *ngIf="modifiers.value > 0" class="col-lg-6 col-md-6 text-right">
                                <b class="color-light-blue">{{modifiers.value | currencySD: restaurantCountry }}</b>
                            </div>

                        </div>

                        <div *ngFor="let subMods of modifiers.subModifiers" class="col-lg-12 col-md-12 col-sm-12 submods d-flex">
                            
                            <div class="col-lg-6 col-md-6 ">
                                <b>
                                    {{subMods.qty | number: '1.0-0'}}&nbsp;&nbsp;
                                    {{subMods.name}}
                                </b>
                            </div>

                            <div *ngIf="subMods.value > 0" class="col-lg-6 col-md-6 ">
                                {{subMods.value | currencySD: restaurantCountry }}
                            </div>

                        </div>

                    </ng-container>

                    <div *ngIf="product.orderObservation.text" class="col-lg-12 col-md-12 col-sm-12 note">
                        
                        <span class="bold-600">{{'NOTE' | translate}}:</span>
                        {{product.orderObservation.text}}

                    </div>

                </ng-container>

            </ng-container>

        </ng-container>

    </div>

    <hr>
    
    <div class="col-lg-12 col-md-12 col-sm-12 bg-light-grey total-detail">

        <div class="col-lg-12 col-md-12 col-sm-12 d-flex">

            <div class="col-lg-6 col-md-6 text-left">
                <b>SUBTOTAL</b>
            </div>

            <div class="col-lg-6 col-md-6 text-right">
                {{ subTotal | currencySD: restaurantCountry }}
            </div>

        </div>

        <div *ngIf="shipping" class="col-lg-12 col-md-12 col-sm-12 d-flex">

            <div class="col-lg-6 col-md-6 text-left">
                <b>{{'DELIVERY' | translate |uppercase}}</b>
            </div>

            <div class="col-lg-6 col-md-6 text-right">
                {{ shipping | currencySD: restaurantCountry}}
            </div>

        </div>

        <div *ngIf="tip" class="col-lg-12 col-md-12 col-sm-12 d-flex">

            <div class="col-lg-6 col-md-6 text-left">
                <b>{{'TIP' | translate |uppercase}}</b>
            </div>

            <div class="col-lg-6 col-md-6 text-right">
                {{ tip | currencySD: restaurantCountry}}
            </div>

        </div>

        <ng-container *ngIf="additionalDetailData">

            <div *ngFor="let tax of arrayTaxes" class="col-lg-12 col-md-12 col-sm-12 d-flex mb-2">

                <ng-container *ngIf="tax.value">

                    <div class="col-lg-6 col-md-6">
                        <b class="color-green">{{'CART_TAX' | translate| uppercase }} {{tax.percent | percent:'1.1-2'}}</b>
                    </div>

                    <div class="col-lg-6 col-md-6 text-right">
                        {{tax.value | currencySD: restaurantCountry}}
                    </div>

                </ng-container>

            </div>

        </ng-container>

        <ng-container *ngIf="couponsDiscount">

            <div class="col-lg-12 col-md-6 text-left">
                <b>{{'DISCOUNTS' | translate |uppercase}}</b>
            </div>

            <hr>

            <div *ngFor="let discount of couponsDiscount" class="col-lg-12 col-md-12 col-sm-12 d-flex submods">

                <div class="col-lg-6 col-md-6">
                    <b class="color-green">{{discount.couponName| uppercase }}</b>
                </div>

                <div *ngIf="discount.discount" class="col-lg-6 col-md-6">
                    - {{discount.discount | currencySD: restaurantCountry}}
                </div>

            </div>

        </ng-container>

        <div *ngIf="orderComment" class="col-lg-12 col-md-12 col-sm-12 note">
            <p><span class="bold-600">{{'ORDER_COMENTARY' | translate}}:</span> {{orderComment}}</p>
        </div>

    </div>

</div>

<div class="modal-footer put-left">
    
    <b class="color-blue">{{ "ORDER_CODE" | translate| uppercase }}</b>&nbsp;
    <b class="color-green"> {{ order.orderCode }}</b>

    <b class="put-right"> TOTAL {{order.invTotal | currencySD: restaurantCountry }} </b>

</div>

<app-change-order-state [orderStateModel]='chargeData()' [buttonProcessing]='orderStatusButtonProcessing' [inputState]='lastOrderState' (sendData)='sendDataOrderState($event)'>
    
</app-change-order-state>